import * as angular from "angular";
import {IRootScopeService} from "angular";
import {select, Store} from "@ngrx/store";
import {CommonsActions} from "../angular/state/commons/commons.actions";

export class BringozLoaderService {

  static $inject = ['store'];

  private store: Store<any>;

  constructor(store: Store<any>) {
    this.store = store;
  }


  on() {
    this.store.dispatch(CommonsActions.setLoaderOn());
  }

  off() {
    this.store.dispatch(CommonsActions.setLoaderOff());
  }

}

angular
  .module('bringoz.admin.commons')
  .service('bringozLoaderService', BringozLoaderService);
